import { render, staticRenderFns } from "./InvestorEventsComponent.vue?vue&type=template&id=0983f952&scoped=true"
import script from "./InvestorEventsComponent.vue?vue&type=script&lang=js"
export * from "./InvestorEventsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983f952",
  null
  
)

export default component.exports